import "./SuvaiGallery.scss"
import store from "../../assets/images/store.png"
import seatings from "../../assets/images/seatings.png"
import { sortByOrderAscending } from "../../helper/helper";
import { useEffect } from "react";
const SuvaiGallery = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const getImages = (images) => {
        const result = [];
        for (let i = 0; i < images.length; i += 5) {
            result.push(images.slice(i, i + 5));
        }
        return result;
    };
    const Components = [
        {
            "ID": "SuvaiGallery-header",
            "Order": 1,
            "Type": "content",
            "Props": {
                "subHeaderText": "Impressions of our Restaurant",
                "headerText": "Gallery"
            }
        },
        {
            "ID": "SuvaiGallery-gallery",
            "Order": 2,
            "Type": "image-grid",
            "Props": null,
            "Data": [
                { "src": store },
                { "src": seatings },
                { "src": "https://images.unsplash.com/photo-1606471191009-63994c53433b?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTV8fGluZGlhbiUyMGZvb2R8ZW58MHx8MHx8fDA%3D" },
                { "src": "https://images.unsplash.com/photo-1505253758473-96b7015fcd40?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTl8fGluZGlhbiUyMGZvb2R8ZW58MHx8MHx8fDA%3D" },
                { "src": "https://plus.unsplash.com/premium_photo-1694670234085-4f38b261ce5b?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8bm9vZGxlc3xlbnwwfHwwfHx8MA%3D%3D" },
                { "src": "https://images.unsplash.com/photo-1732519970445-8f2d6998961f?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8c2Ftb3NhfGVufDB8fDB8fHww" },
                { "src": "https://images.unsplash.com/photo-1679310290259-78d9eaa32700?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8c3ByaW5nJTIwcm9sbHN8ZW58MHx8MHx8fDA%3D" },
                { "src": "https://images.unsplash.com/photo-1694849789325-914b71ab4075?q=80&w=1074&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
                { "src": "https://images.unsplash.com/photo-1683533698971-dcc5e19cb0f1?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTR8fGNoYWl8ZW58MHx8MHx8fDA%3D" },
                { "src": "https://images.unsplash.com/photo-1631452180519-c014fe946bc7?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8cGFuZWVyfGVufDB8fDB8fHww" },
                { "src": "https://plus.unsplash.com/premium_photo-1695297516676-04a259917c03?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8c2Ftb3NhfGVufDB8fDB8fHww" },
                { "src": "https://images.unsplash.com/photo-1505252585461-04db1eb84625?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTZ8fGp1aWNlc3xlbnwwfHwwfHx8MA%3D%3D" },
                { "src": "https://images.unsplash.com/photo-1701579231378-3726490a407b?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8cGFuZWVyfGVufDB8fDB8fHww" },
                { "src": "https://images.unsplash.com/photo-1683533698664-12ee473e8c9d?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8Y2hhaXxlbnwwfHwwfHx8MA%3D%3D" },
                { "src": "https://images.unsplash.com/photo-1705359573325-f2006d5e459f?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8dGFuZG9vcml8ZW58MHx8MHx8fDA%3D" },
            ]
        }

    ]
    const getHeaderontent = (props) => {
        return (
            <div className="SuvaiGallery-header">
                <div className="SuvaiGallery-header-subtext">
                    {props.subHeaderText}
                </div>
                <div className="SuvaiGallery-header-text">{props.headerText}</div>
            </div>
        )
    }
    const getGalleryContent = (data) => {
        return (
            <div className="SuvaiGallery-gallery">
                {getImages(data).map((images, index) => (
                    <div
                        className={`SuvaiGallery-gallery-inner ${index % 2 === 0 ? "" : "reversed"}`}
                        key={index}
                    >
                        <div className="SuvaiGallery-gallery-inner-left">
                            <img src={images[0].src} alt="" />
                        </div>
                        <div className="SuvaiGallery-gallery-inner-right">
                            {images.slice(1).map((img, key) => (
                                <img src={img.src} alt="" key={key} />
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        )
    }
    const getComponents = (component) => {
        switch (component.ID) {
            case "SuvaiGallery-header":
                return getHeaderontent(component.Props)
            case "SuvaiGallery-gallery":
                return getGalleryContent(component?.Data)
            default:
                return <div />
        }

    }
    return (
        <div className="SuvaiGallery">
            {sortByOrderAscending(Components).map((component, key) => {
                return getComponents(component)
            })}
        </div>
    );
};

export default SuvaiGallery;